import { RedactedTaxIdentifierSchema } from "@redotech/redo-model/outbound-labels/customs";
import { z, null as zNull } from "zod";

// we should never send the tax identifier number to the client
export const getTaxIdentifiers = {
  input: zNull(),
  output: z.object({ identifiers: z.array(RedactedTaxIdentifierSchema) }),
};
